import { render, staticRenderFns } from "./AssignmentConSwiper.vue?vue&type=template&id=228ab718&"
import script from "./AssignmentConSwiper.vue?vue&type=script&lang=js&"
export * from "./AssignmentConSwiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports